import { render } from "./DoiPageView.vue?vue&type=template&id=3356bbf6&scoped=true"
import script from "./DoiPageView.vue?vue&type=script&lang=js"
export * from "./DoiPageView.vue?vue&type=script&lang=js"

import "./DoiPageView.vue?vue&type=style&index=0&id=3356bbf6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3356bbf6"]])

export default __exports__